// extracted by mini-css-extract-plugin
export default {"companyContainer":"EN-z","companyImage":"FN-z","container":"GN-z","heading":"HN-z","darkText":"IN-z","smallHeading":"JN-z","darkBackground":"KN-z","whiteBackground":"LN-z"};